// extracted by mini-css-extract-plugin
export default {"content":"DrawerWrapper_content__5u2oW","drawer":"DrawerWrapper_drawer__npqEn"};